import React from 'react'

export default function Carbon() {
    return (
        <div>
            <svg width="100" height="100" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M31.25 50H68.75V56.25H31.25V50ZM31.25 31.25H68.75V37.5H31.25V31.25Z" fill="#BB0600" />
                <path d="M50 93.75L30.7 83.4594C25.1979 80.5322 20.5968 76.162 17.3904 70.8179C14.184 65.4737 12.4934 59.3573 12.5 53.125V12.5C12.5017 10.8429 13.1607 9.25415 14.3324 8.08241C15.5042 6.91067 17.0929 6.25165 18.75 6.25H81.25C82.9071 6.25165 84.4959 6.91067 85.6676 8.08241C86.8393 9.25415 87.4984 10.8429 87.5 12.5V53.125C87.5066 59.3573 85.816 65.4737 82.6096 70.8179C79.4032 76.162 74.8021 80.5322 69.3 83.4594L50 93.75ZM18.75 12.5V53.125C18.7448 58.2244 20.1285 63.2289 22.7524 67.6014C25.3763 71.9739 29.1415 75.5493 33.6438 77.9437L50 86.6656L66.3563 77.9469C70.859 75.5522 74.6245 71.9763 77.2484 67.6032C79.8724 63.2301 81.2558 58.2249 81.25 53.125V12.5H18.75Z" fill="#BB0600" />
            </svg>
        </div>
    )
}
